import { Navigate, useParams } from "react-router-dom";

export default function TherapistDetailRouteAlias() {
  const { id } = useParams();
  const target = id ? `/therapist-detail?id=${id}` : "/therapist-detail";
  return <Navigate replace to={target} />;
}
